import LoadGoogleMapsAPI from 'load-google-maps-api'
import Config from '../config.js'

var _gMapsApiLoader = null;

export default class MapsAPI {

  constructor ($container, options) {

    this.settings = $.extend({}, {
      apiKey: Config.mapsApiKey
    }, options)

    if (_gMapsApiLoader === null) {
      _gMapsApiLoader = LoadGoogleMapsAPI({
        key: this.settings.apiKey
      })
    }

    return _gMapsApiLoader.catch(err => {
      console.error(err)
    })

  }
}
